// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__1xLNL","containerItemsCenter":"Skeleton_containerItemsCenter__3VDfG"};